import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirect } from "@/lib/legacy-redirect";

export const Route = createFileRoute("/commercial-hvac")({
  beforeLoad: () => legacyRedirect("/hvac-services/commercial-hvac"),
});
